import Vue from 'vue'
import Pagination from './pagination'
import Helper from './helper'
import Datepicker from './datepicker'
import Sort from './sort'
import Validator from './validator'
import Display from './display'
import Api from './api'
Vue.mixin(Pagination)
Vue.mixin(Helper)
Vue.mixin(Datepicker)
Vue.mixin(Sort)
Vue.mixin(Validator)
Vue.mixin(Display)
Vue.mixin(Api)
